import { useCallback, useContext } from 'react';
import { usePaymentContext } from '../PaymentProvider';
import { ModalsContext } from 'contexts/modals';
import { useFlittWallets } from 'libs/hooks/flitt';

const Wallets = () => {
  const { callResponse } = useContext(ModalsContext);
  const { fetchToken, merchantId, totalAmount, onSuccess: handleSuccess, walletToken } = usePaymentContext();

  const onSuccess = useCallback(() => {
    handleSuccess();
  }, [handleSuccess]);

  const onError = useCallback((model) => {
    if(model.attr)  {
      callResponse({ statusCode: false, statusMessage: model.attr('error.message') });
    }
  }, [callResponse]);

  useFlittWallets({
    methods: ['google'],
    element: '.flitt_payment_container_google',
    amount: totalAmount,
    merchantId,
    onSuccess,
    onError,
    // handleToken: fetchToken,
    params: {
      token: walletToken
    }

  });

  return (
    <div className="max-width-md-150px" style={{ width: '100%' }}>
      <div className="flitt_payment_container_google"></div>
    </div>
  );
};

export default Wallets;
